var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingShipment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1416 17.6276L17.9116 9.79763C17.3832 8.84268 16.378 8.25 15.2866 8.25C14.1952 8.25 13.19 8.84268 12.6616 9.79763L8.36411 17.6201C7.85921 18.5492 7.88067 19.6754 8.42062 20.5846C8.96056 21.4937 9.93922 22.0514 10.9966 22.0526H19.5016C20.5581 22.0526 21.5367 21.497 22.078 20.5897C22.6193 19.6824 22.6434 18.5573 22.1416 17.6276ZM14.6416 13.3076C14.6416 12.997 14.8934 12.7451 15.2041 12.7451C15.5148 12.7451 15.7666 12.997 15.7666 13.3076V15.6251C15.7666 15.9358 15.5148 16.1876 15.2041 16.1876C14.8934 16.1876 14.6416 15.9358 14.6416 15.6251V13.3076ZM15.2116 18.3701C15.5223 18.3701 15.7741 18.1183 15.7741 17.8076L15.7666 17.8001C15.7666 17.4936 15.5181 17.2451 15.2116 17.2451C14.9026 17.2492 14.6531 17.4987 14.6491 17.8076C14.6491 18.1183 14.9009 18.3701 15.2116 18.3701Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingShipment);
export default __webpack_public_path__ + "static/media/pendingShipment.9688e53b8af7722288105076275f9751.svg";
export { ForwardRef as ReactComponent };